// extracted by mini-css-extract-plugin
export default {"dayTooltip":"period_tooltips-module___dayTooltip___e75aee30"};